<template>
  <el-table-column
    prop="user.last_name"
    sortable="custom"
    label="Felelős"
    show-overflow-tooltip
    min-width="130"
  >
    <template slot-scope="scope">
      {{ scope.row.user && scope.row.user.last_name }} {{ scope.row.user && scope.row.user.first_name }}
    </template>
  </el-table-column>
</template>

<script>
export default {
  propName: 'user.last_name',
};
</script>
